import { render, staticRenderFns } from "./Onequan.vue?vue&type=template&id=0af90e73&scoped=true&"
import script from "./Onequan.vue?vue&type=script&lang=js&"
export * from "./Onequan.vue?vue&type=script&lang=js&"
import style0 from "./Onequan.vue?vue&type=style&index=0&id=0af90e73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af90e73",
  null
  
)

export default component.exports